import { Routes } from '@angular/router';
import { RouterModule } from  '@angular/router';
import {NgModule} from "@angular/core";
import {PortalService} from "../services/portal.service";
import {AdvisorPagenotfoundComponent} from "../advisor.pagenotfound.component";
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {StepChapterComponent} from "../step/step.chapter.component";
import {EinstiegChapterComponent} from "./einstieg/einstieg.chapter.component";
import {VerbrauchsanalyseStepComponent} from "./verbrauchsanalyse/verbrauchsanalyse.step.component";
import {VerbrauchsanalyseHeizcheckStepVerbrauchsdatenComponent} from "./verbrauchsanalyse/verbrauchsanalyse-heizcheck.step.verbrauchsdaten.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {HeizkostenabrechnungStartComponent} from "./heizkostenabrechnung/heizkostenabrechnung.start.component";
import {VerbrauchsanalyseHeizcheckAusstiegComponent} from "./verbrauchsanalyse/verbrauchsanalyse-heizcheck.ausstieg.component";
import {HeizkostenabrechnungStepComponent} from "./heizkostenabrechnung/heizkostenabrechnung.step.component";
import {AuswertenComponent} from "./auswerten/auswerten.component";
import {HeizkostenabrechnungAusstiegComponent} from "./heizkostenabrechnung/heizkostenabrechnung.ausstieg.component";
import {HeizkostenabrechnungVerbrauchseingabeStepComponent} from "./heizkostenabrechnung/heizkostenabrechnung.verbrauchseingabe.step.component";
import {HeizkostenabrechnungKostenStepComponent} from "./heizkostenabrechnung/heizkostenabrechnung.kosten.step.component";
import {ErfassenComponent} from "./erfassen/erfassen.component";
import {FotoComponent} from "./foto/foto.component";
import {HeizcheckEnergyMapComponent} from "./energy-map/heizcheck.energy.map.component";
import {HeizcheckEnergyMapDonatedComponent} from "./energy-map/heizcheck.energy.map.donated.component";

/**
 * Routes for the heizcheck.
 * The default route leads to heizcheck here
 */
const routes: Routes = [
  { path: ':portalId/heizcheck', children: [
    // default step is 'einstieg'
    { path: '', redirectTo: 'einstieg', pathMatch: 'full' },
    // entry questions
    { path: 'einstieg', component: EinstiegChapterComponent, data: {ignoreInNav: true}, children: [
      { path: 'nutzungstyp', component: EinstiegComponent, data: {swipeCount: '1'}},
      { path: 'gebaeudetyp', component: EinstiegComponent, data: {swipeCount: '2'}},
      { path: 'heizungstyp', component: EinstiegComponent, data: {swipeCount: '3'}},
      { path: '', redirectTo: 'nutzungstyp', pathMatch: 'full' },
    ]},
    { path: 'foto', component: FotoComponent, data: {swipeCount: '99', ignoreInNav: true} },
    // first input section and result page
    { path: 'verbrauchsanalyse', component: StepChapterComponent, data: {ignoreInNav: function(currentUrl) {return !currentUrl.match('verbrauchsanalyse')}}, children: [
      { path: 'basisinformationen/1', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '2'}},
      { path: 'basisinformationen/2', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '3'}},
      { path: 'basisinformationen/3', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '4'}},
      { path: 'basisinformationen/4', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '5'}},
      { path: 'basisinformationen/5', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '6'}},
      { path: 'basisinformationen/6', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '7'}},

      { path: 'heizsystem/1', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '10'}},
      { path: 'heizsystem/2', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '11'}},
      { path: 'heizsystem/3', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '12'}},
      { path: 'heizsystem/4', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '13'}},
      { path: 'heizsystem/5', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '14'}},
      { path: 'heizsystem/6', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '15'}},
      { path: 'heizsystem/7', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '16'}},
      { path: 'heizsystem/8', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '17'}},
      { path: 'heizsystem/9', component: VerbrauchsanalyseStepComponent, data: {swipeCount: '18'}},

      { path: 'verbrauchsdaten', component: VerbrauchsanalyseHeizcheckStepVerbrauchsdatenComponent, data: {swipeCount: '20'}},
      { path: 'energy-map', component: HeizcheckEnergyMapComponent, data: {swipeCount: '21', ignoreInNav: true}},
      { path: 'energy-map-donated', component: HeizcheckEnergyMapDonatedComponent, data: {swipeCount: '22', ignoreInNav: true}},

      { path: 'ausstieg', component: VerbrauchsanalyseHeizcheckAusstiegComponent, data: {swipeCount: '30', ignoreInNav: true, isDeadEnd: true}},

      { path: '', redirectTo: 'basisinformationen/1', pathMatch: 'full' },
    ]},
    { path: 'heizkostenabrechnung', component: StepChapterComponent, data: {ignoreInNav: function(currentUrl) {return !currentUrl.match('heizkostenabrechnung')}}, children: [
      { path: 'start', component: HeizkostenabrechnungStartComponent, data: {swipeCount: '1'}},

      { path: 'start/upload', component: ErfassenComponent, data: {swipeCount: '2', mode: 'upload'}},
      { path: 'start/foto', component: ErfassenComponent, data: {swipeCount: '3', mode: 'foto'}},

      { path: 'basisdaten/1', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '10'}},
      { path: 'basisdaten/2', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '11'}},
      { path: 'basisdaten/3', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '12'}},
      { path: 'basisdaten/4', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '13'}},
      { path: 'basisdaten/5', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '14'}},
      { path: 'basisdaten/6', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '15'}},
      { path: 'basisdaten/7', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '16'}},
      { path: 'basisdaten/8', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '17'}},
      { path: 'basisdaten/9', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '18'}},

      { path: 'verbrauchseingabe', component: HeizkostenabrechnungVerbrauchseingabeStepComponent, data: {swipeCount: '20'}},

      { path: 'kostendetails', component: HeizkostenabrechnungKostenStepComponent, data: {swipeCount: '30'}},

      { path: 'sonstiges/1', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '41'}},
      { path: 'sonstiges/2', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '42'}},
      { path: 'sonstiges/3', component: HeizkostenabrechnungStepComponent, data: {swipeCount: '43'}},

      { path: 'energy-map', component: HeizcheckEnergyMapComponent, data: {swipeCount: '44', ignoreInNav: true}},
      { path: 'energy-map-donated', component: HeizcheckEnergyMapDonatedComponent, data: {swipeCount: '45', ignoreInNav: true}},

      { path: 'ausstieg', component: HeizkostenabrechnungAusstiegComponent, data: {swipeCount: '60', ignoreInNav: true, isDeadEnd: true}},

      { path: '', redirectTo: 'start', pathMatch: 'full' },

    ]},
    { path: 'ergebnis', component: StepChapterComponent, data: {ignoreInNav: function(currentUrl) {return !currentUrl.match('verbrauchsanalyse')}}, children: [
      { path: 'verbrauchsanalyse', component: ErgebnisComponent, data: {swipeCount: '1', advisor: 'heizcheck'}},
      { path: '', redirectTo: 'verbrauchsanalyse', pathMatch: 'full' },
    ]},
    { path: 'auswerten', component: StepChapterComponent, data: {ignoreInNav: function(currentUrl) {return !currentUrl.match('heizkostenabrechnung')}}, children: [
        { path: 'heizkostenabrechnung', component: AuswertenComponent, data: {swipeCount: '1', advisor: 'heizcheck'}},
        { path: '', redirectTo: 'heizkostenabrechnung', pathMatch: 'full' },
      ]},
  ]},
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/heizcheck', pathMatch: 'full'},
  {path: 'heizcheck/', redirectTo: PortalService.defaultPortal + '/heizcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/heizcheck', pathMatch: 'full'},
  {path: '**', pathMatch: 'full', component: AdvisorPagenotfoundComponent, data: {advisor: 'heizcheck'}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class HeizcheckRoutingModule { }
